var map = {
	"./AU.png": "./src/assets/images/icons/flags/AU.png",
	"./BR.png": "./src/assets/images/icons/flags/BR.png",
	"./CA.png": "./src/assets/images/icons/flags/CA.png",
	"./DE.png": "./src/assets/images/icons/flags/DE.png",
	"./GB.png": "./src/assets/images/icons/flags/GB.png",
	"./TW.png": "./src/assets/images/icons/flags/TW.png",
	"./US.png": "./src/assets/images/icons/flags/US.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/icons/flags sync recursive ^\\.\\/.*\\.png$";